import i18n from 'i18next';

/**
 * Review r4 B8 (segurança): o login nunca mostra texto vindo da URL (`?msg=` abria espaço para phishing).
 * A URL leva só um código conhecido; o texto vem do dicionário no idioma do app. Qualquer outro valor é ignorado.
 */
export const MENSAGENS_LOGIN: Readonly<Record<string, string>> = {
  senha_redefinida: 'login.redefinida',
  convite_aceito: 'login.conviteAceito',
  // Val7 (rval7 ROB-1): a conta nasceu só com o nome de usuário (o e-mail de login desmarcado no convite).
  convite_aceito_usuario: 'login.conviteAceitoUsuario',
  // Review r29 spec (O2): o 401 no meio da sessão (encerrada por outra aba, outro aparelho ou a validade) chega ao login com aviso.
  sessao_encerrada: 'login.sessaoEncerrada',
  // val1 (28/10): troca do e-mail da conta confirmada pelo link.
  email_confirmado: 'login.emailConfirmado',
};

/** Chave i18n da mensagem do código, ou `null` quando o código não está na lista (inclui texto arbitrário). */
export function chaveMensagemLogin(codigo: string | null | undefined): string | null {
  if (!codigo || !Object.prototype.hasOwnProperty.call(MENSAGENS_LOGIN, codigo)) return null;
  return MENSAGENS_LOGIN[codigo] ?? null;
}

/** `voltar` só aceita caminho interno ("/financeiro"); URL absoluta ou "//outro.site" volta para a raiz. */
export function destinoSeguro(voltar: string | null | undefined): string {
  return voltar && /^\/(?![/\\])/.test(voltar) ? voltar : '/';
}

/**
 * Review r21 visual (B1): o 429 do login (senha ou código) diz quanto falta pelo tempo que a API mandou (`details.segundos` do
 * bloqueio ou o `Retry-After` do limite por rota): até 59 minutos em minutos, depois em horas ("cerca de 1 hora" no bloqueio do
 * segundo fator, o mesmo que o e-mail `mfa_bloqueado` diz). Sem o tempo, "mais tarde" (nunca "alguns minutos").
 */
export function mensagemBloqueioLogin(segundos: number | null | undefined): string {
  if (typeof segundos !== 'number' || !Number.isFinite(segundos) || segundos <= 0) return i18n.t('login.bloqueado');
  const minutos = Math.ceil(segundos / 60);
  if (minutos < 60) return i18n.t('login.bloqueadoMinutos', { count: minutos });
  return i18n.t('login.bloqueadoHoras', { count: Math.max(1, Math.round(segundos / 3600)) });
}
